export default __webpack_public_path__ + "320cadb27c3a8b64fd93c0d8d8c2505b.jpeg";